// extracted by mini-css-extract-plugin
module.exports = {"row":"FaqSection_row__jxDvj","rowHeader":"FaqSection_rowHeader__601SS","isExpanded":"FaqSection_isExpanded__F7yAc","arrow":"FaqSection_arrow__32V9b"};